export default __webpack_public_path__ + "static/media/nextjs.0bae0f55.png";